import React, { Component } from 'react';
import { connect } from 'react-redux';
import Table from '../../../components/UI/Table/Table';
import Blank from '../../../hoc/Blank/Blank';
import Spinner from '../../../components/UI/Spinner/Spinner';
import * as actions from '../../../store/actions/index';
import 'react-toastify/dist/ReactToastify.min.css' ;
import { ToastContainer,toast } from 'react-toastify';

class CallList extends Component {
  componentDidMount() {
    this.props.onFetchCallList();
    window.scrollTo(0,0);
  }

  state = {
    showEditOrder: false,
    showSuccess: false,
    orderId: 0,
    width: window.innerWidth,
    callListOrder: null,
    purchased: false,
    result: null
  }

  componentDidUpdate(prevProps) {

      
    if (this.props.result != "0") {
      let message = "The order was successfully added.";
      if (!this.state.result || this.state.result != this.props.result  ) {
        this.setState({result:this.props.result});
        toast(message);
      }
    }
}


  showOrder = (e) => {
    this.setState({result:""});
    let oid = e.currentTarget.getAttribute('oid');
    this.props.history.push('/editOrder?' + oid);
  }


  render() {

    if (!this.props.loading) {

      var data = [];
      let pl = "30px";
      let fifty = "50px";
      let oneFifty = "150px";
      let seventyFive = "75px";

      if (window.innerWidth < 500) {
        pl = "5px";
        fifty = "40px";
        oneFifty = "100px";
        seventyFive = "50px";
      }

      let i = -1;

      for (let k1 in this.props.orders) {
        let order = this.props.orders[k1]
        data.push({
          oid: order.orderId, data: [{
            value: order.orderId,
            style: { paddingLeft: pl, width: seventyFive },
            full: false
          },
          {
            value: order.name,
            style: { width: oneFifty, paddingLeft: pl },
            full: false
          },
          {
            value: order.address,
            style: { width: "250px", paddingLeft: pl },
            full: true
          },
          {
            value: order.phone,
            style: { width: seventyFive, paddingLeft: pl },
            full: true
          },
          {
            value: order.email,
            style: { width: oneFifty, paddingLeft: pl },
            full: true
          }
        ]})

        i = i + 1

        if (this.props.mulchYear.sellHardwood) {
          data[i].data.push(
          {
            value: order.hardwoodBags,
            style: { width: fifty, paddingLeft: pl },
            full: false
          })
        }

        if (this.props.mulchYear.sellCedar) {
          data[i].data.push(
          {
            value: order.cedarBags,
            style: { width: fifty, paddingLeft: pl },
            full: false
          })
        }

        if (this.props.mulchYear.sellBlack) {
          data[i].data.push(
          {
            value: order.blackBags,
            style: { width: fifty, paddingLeft: pl },
            full: false
          })
        }

        if (this.props.mulchYear.sellRed) {
          data[i].data.push(
          {
            value: order.redBags,
            style: { width: fifty, paddingLeft: pl },
            full: false
          })
        }

        data[i].data.push(
          {
            value: order.lastMulchYear,
            style: { width: seventyFive, paddingLeft: pl },
            full: true
          }
        )
        }   
      var header = [{
        name: "Order",
        style: { paddingLeft: pl, width: seventyFive }
      },
      {
        name: "Name",
        style: { width: oneFifty, paddingLeft: pl }
      },
      {
        name: "Address",
        style: { width: "200px", paddingLeft: pl },
        full: true
      },
      {
        name: "Phone",
        style: { width: seventyFive, paddingLeft: pl },
        full: true
      },
      {
        name: "Email",
        style: { width: oneFifty, paddingLeft: pl },
        full: true
      }]

      if (this.props.mulchYear.sellHardwood) {
        header.push(
      {
        name: "Hwd",
        style: { width: fifty, paddingLeft: pl }
      })
    }

    if (this.props.mulchYear.sellCedar) {
      header.push(
      {
        name: "Cdr",
        style: { width: fifty, paddingLeft: pl }
      })
    }

    if (this.props.mulchYear.sellBlack) {
      header.push(
      {
        name: "Blk",
        style: { width: fifty, paddingLeft: pl }
      })
    }

    if (this.props.mulchYear.sellRed) {
      header.push(
      {
        name: "Red",
        style: { width: fifty, paddingLeft: pl }
      })
    }

    header.push(
      {
        name: "Last Year",
        style: { width: seventyFive, paddingLeft: pl },
        full: false
      }
    );

      return (

        <Blank>
          <ToastContainer autoClose={3000} />
          <Table header={header} data={data} editPopupHandler={this.showOrder}></Table>
        </Blank>
      );
    }
    else {
      return (
        <div>
          <Spinner />
        </div>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    mulchYear: state.orders.mulchYear,
    orders: state.orders.callList,
    loading: state.orders.loading,
    purchased: state.orders.purchased
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetchCallList: () => dispatch(actions.fetchCallList())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CallList);


// WEBPACK FOOTER //
// ./src/containers/Orders/CallList/CallList.js